import useApi, { ApiOptions } from '../base/useApi';
import CardFilterDTO from '@src/adapters/dto/card/CardFilterDTO';
import CardChangeRequestDTO from '@src/adapters/dto/card/CardChangeRequestDTO';

interface Params {
  filter: CardFilterDTO;
}

interface Result {
  cards: CardChangeRequestDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/card/change-requests',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetChangeRequests = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetChangeRequests;
